import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import CopyAllRoundedIcon from "@mui/icons-material/CopyAllRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../contexts/ConfigContext";

function TemplateHome() {
  const navigate = useNavigate();
  const config = useConfig();
  const checkListEnabled = Boolean(config?.features?.enableCheckList);

  const handleEditExistingTemplate = () => {
    navigate("/templates/select-base-template?mode=edit");
  };

  const handleCreateFromTemplate = () => {
    navigate("/templates/select-base-template?mode=duplicate");
  };

  const handleCreateNewTemplate = () => {
    navigate("/templates/new");
  };

  const handleTemplateSettings = () => {
    navigate("/templates/settings");
  };

  const handleCreateTodoOrChecklist = () => {
    navigate("/templates/select-template");
  };

  const actions = [
    {
      title: "テンプレートを新規作成",
      icon: <AutoAwesomeRoundedIcon color="primary" />,
      onClick: handleCreateNewTemplate,
    },
    {
      title: "既存テンプレートを選んで編集",
      icon: <EditNoteRoundedIcon color="primary" />,
      onClick: handleEditExistingTemplate,
    },
    {
      title: "既存のテンプレートをもとに作成",
      icon: <CopyAllRoundedIcon color="primary" />,
      onClick: handleCreateFromTemplate,
    },
    {
      title: "自動生成に使うテンプレート設定",
      icon: <SettingsSuggestRoundedIcon color="primary" />,
      onClick: handleTemplateSettings,
    },
    {
      title: checkListEnabled
        ? "テンプレートからワースケ/チェックリストを作成する"
        : "テンプレートからワースケを作成する",
      icon: <AssignmentTurnedInRoundedIcon color="primary" />,
      onClick: handleCreateTodoOrChecklist,
    },
  ];

  return (
    <Grid container spacing={2.5}>
        {actions.map((action) => (
          <Grid item xs={12} md={6} xl={3} key={action.title}>
            <Card sx={{ height: "100%" }}>
              <CardActionArea onClick={action.onClick} sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    py: 2,
                    px: 2.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                  }}
                >
                  {action.icon}
                  <Typography variant="subtitle1">{action.title}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
  );
}

export default TemplateHome;
